import { Button, Stack, Text } from "@towersystems/roam-common-native";
import { Spacings, View } from "react-native-ui-lib";
import { Dialog } from "react-native-ui-lib/src/incubator";

export interface ConfirmationPromptProps {
  visible: boolean;
  onCancelPress: () => void;
  onConfirmPress: () => void;
  title: string;
  description: string;
  disabled?: boolean;
}

export const ConfirmationPrompt = ({
  visible,
  onCancelPress,
  onConfirmPress,
  title,
  description,
  disabled,
}: ConfirmationPromptProps) => {
  /* The closing animation will break everything if we don't do this */
  return visible ? (
    <Dialog
      visible={visible}
      onDismiss={() => console.log("dismissed")}
      direction="up"
      ignoreBackgroundPress
      centerV
      containerStyle={{
        padding: Spacings.s6,
        borderRadius: 10,
        width: "auto",
      }}
    >
      <View style={{ gap: Spacings.s4, alignItems: "center" }}>
        <Text textAlign="center" variant="heading" fontWeight="bold">
          {title}
        </Text>
        <Text textAlign="center" color="subdued">
          {description}
        </Text>
      </View>
      <View style={{ marginTop: Spacings.s4, alignItems: "center" }}>
        <Stack>
          <Button label="Cancel" onPress={onCancelPress}></Button>
          <Button
            isAction
            label="Confirm"
            disabled={disabled}
            onPress={onConfirmPress}
          ></Button>
        </Stack>
      </View>
    </Dialog>
  ) : null;
};
